import * as Yup from "yup";
import {
  maxDigitsValidation,
  maxLengthValidation,
} from "../utils/MaxLengthValidation";
import moment from "moment";
import momentHijri from "moment-hijri";

export const BeneficiaryValidationSchema = (t) =>
  Yup.object({
    is_update_episode: Yup.boolean(),
    // benificiaryType: Yup.string().trim().required('Beneficiary type is required'),
    fullName: Yup.string()
      .trim()
      .concat(maxLengthValidation(50))
      .required(t("Full name is required")),
    dob: Yup.date()
      .required(t("Date of birth is required"))
      .max(moment().endOf("day").toDate(), t("Date of birth cannot be in the future"))
      .min(
        moment().subtract(150, "years").startOf("day").toDate(),
        t("Age cannot be more than 150 years")
      ),
    gender: Yup.string().trim().required(t("Gender is required")),
    occupation: Yup.string().trim().required(t("Occupation is required")),
    occupationOther: Yup.string().when("occupation", {
      is: "others",
      then: () =>
        Yup.string()
          .trim()
          .concat(maxLengthValidation(50))
          .required(t("Occupation is required")),
      otherwise: () => Yup.string().trim().notRequired(),
    }),
    religion: Yup.string().trim().required(t("Religion is required")),
    documentType: Yup.string().trim().required(t("Document type is required")),
    documentId: Yup.string().when(["documentType", "is_new_born"], {
      is: (_documentType, isNewBorn) => isNewBorn,
      then: () =>
        Yup.string().trim().required(t("Document ID is required")),
      otherwise: (schema) =>
        schema.when("documentType", {
          is: "NI",
          then: () =>
            Yup.string()
              .matches(/^\d{10}$/, "Document ID must be exactly 10 digits")
              .typeError("Must be a number field")
              .required(t("Document ID is required")),
          otherwise: () =>
            Yup.string()
              .trim()
              .matches(/^[a-zA-Z0-9]+$/, "Document ID must be alphanumeric")
              .max(40, t("Document id must be at most 40 characters long"))
              .required(t("Document ID is required")),
        }),
    }),
    nationality: Yup.string().trim().required(t("Nationality is required")),
    residencyType: Yup.string().trim().required(t("Residency type is required")),
    contactNo: Yup.number()
      .typeError("Must be a number field")
      .concat(maxDigitsValidation(10, t))
      .required(t("Contact number is required")),
    address: Yup.string()
      .trim()
      .concat(maxLengthValidation(100))
      .required(t("Address is required")),
    martialStatus: Yup.string().trim().required(t("Marital status is required")),
    passportNo: Yup.string().when("documentType", {
      is: "PPN",
      then: () =>
        Yup.string()
          .trim()
          .matches(/^[a-zA-Z0-9]+$/, "Passport number must be alphanumeric")
          .concat(maxLengthValidation(40))
          .required(t("Passport number is required")),
      otherwise: () => Yup.string().notRequired(),
    }),
    visaTitle: Yup.string().trim().concat(maxLengthValidation(40)),
    visaNumber: Yup.string().trim().concat(maxLengthValidation(40)),
    borderNo: Yup.string().trim().concat(maxLengthValidation(40)),
    insuranceDuration: Yup.string().trim().concat(maxLengthValidation(40)),
    email: Yup.string().when("user_login", {
      is: true,

      then: () =>
        Yup.string()
          .trim()
          .required(t("Email is required"))
          .email(t("Invalid email format")),
      otherwise: () => Yup.string().notRequired(),
    }),
    password: Yup.string().when("user_login", {
      is: true,
      then: () => Yup.string().trim().required(t("Password is required")),
      otherwise: () => Yup.string().trim().notRequired(),
    }),
    old_file_no: Yup.string().trim(),
  });

export const emergencyContactsValidationSchema = (t) => Yup.object({
  type: Yup.string().trim().required(t("Type is required")),
  first_name: Yup.string()
    .trim()
    .concat(maxLengthValidation(40))
    .required(t("First Name is required")),
  last_name: Yup.string()
    .trim()
    .concat(maxLengthValidation(40))
    .required(t("Last Name is required")),
  relationship: Yup.string()
    .trim()
    .concat(maxLengthValidation(40))
    .required(t("Relationship is required")),
  phone_number: Yup.number()
    .typeError("Must be a number field")
    .concat(maxDigitsValidation(10)),
  comments: Yup.string().trim().concat(maxLengthValidation(300)),
});

export const guarantorValidationSchema = (t) => Yup.object({
  relation_with_patient: Yup.string()
    .trim()
    .concat(maxLengthValidation(40))
    .required(t("Relation with patient is required")),
  name: Yup.string()
    .trim()
    .concat(maxLengthValidation(40))
    .required(t("Name is required")),
  phone: Yup.number()
    .typeError("Must be a number field")
    .concat(maxDigitsValidation(10)),
  address: Yup.string().trim().concat(maxLengthValidation(50)),
});

// documentId: Yup.string().when('documentType', {
//   is: 'VP',
//   then: () =>
//     Yup.string()
//       .matches(/^\d{10,15}$/, 'Document ID must be between 10 and 15 digits')
//       .typeError('Must be a number field')
//       .required('Document ID is required'),
//   otherwise: () =>
//     Yup.string()
//       .matches(/^\d{10}$/, 'Document ID must be exactly 10 digits')
//       .typeError('Must be a number field')
//       .required('Document ID is required')
// }),
